import React, { useEffect, useState } from "react";
import momentTimezone from "moment-timezone";
import moment from "moment";

import styles from "./timezone-select.module.scss";

interface TimezoneSelectProps {
  timezone?: string | null;
  onChange: (timezone: string) => void;
}

const TimezoneSelect: React.FC<TimezoneSelectProps> = (props: TimezoneSelectProps) => {
  const { timezone, onChange }: TimezoneSelectProps = props;

  const [time, setTime]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>("");

  const timezones: string[] = momentTimezone.tz
    .names()
    .filter(tz => tz.startsWith("America") || tz.startsWith("Canada") || tz.startsWith("Mexico"));

  useEffect(() => {
    if (!timezone) {
      setTime("");
      return;
    }

    setTime(moment().tz(timezone).format("HH:mm"));
    const interval: NodeJS.Timeout = setInterval(() => {
      setTime(moment().tz(timezone).format("HH:mm"));
    }, 30000);

    return (): void => clearInterval(interval);
  }, [timezone]);

  return (
    <div className={styles.timezoneSelectWrapper}>
      <div className={styles.timezoneSelect}>
        TZ:{" "}
        <select name="timezone" value={props.timezone ?? ""} onChange={(e): void => onChange(e.target.value)}>
          <option></option>
          {timezones.map((tz, i) => (
            <option key={i} value={tz}>
              {tz}
            </option>
          ))}
        </select>
      </div>
      {timezone && <div className={styles.time}>Time: {time}</div>}
    </div>
  );
};

export default TimezoneSelect;
